export default "__VITE_ASSET__DhjA$ATd__"